import CustomTabPane, { TabProps } from "@/components/TabPane";
import { AddPackBoxItem, BoxItem, PackBox } from "@/types/packing";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import BoxList from "./BoxList";
import ItemList from "./ItemList";
import SDoc from "@/components/SDoc";
import WDocFileListTab from "@/components/WDocFileListTab";
interface PackBoxHomeProps {
  editItem: (itemId: string, data: AddPackBoxItem, notip?: boolean) => Promise<BoxItem | undefined>;
  readonly?: boolean;
};

type CustomerTabType = "box" | "item" | "doc" | "fileList";
export const TAB_BOX_KEY: CustomerTabType = "box";
export const TAB_ITEM_KEY: CustomerTabType = "item";
export const TAB_DOC_KEY: CustomerTabType = "doc";
export const TAB_FILE_LIST: CustomerTabType = "fileList";
const PackBoxHome: FC<PackBoxHomeProps> = ({ readonly = false, editItem }) => {
  const { t } = useTranslation();

  const handleItemDoc = (info: BoxItem, docId: string) => {
    editItem(info.id, {
      productId: info.productId,
      docId,
      count: info.count,
      lot: info.lot,
      declaredCurrency: info.declaredCurrency,
      declaredUnitPrice: info.declaredAmount,
      hsCode: info.hsCode,
      originPlace: info.originPlace,
      productNameCn: info.productNameCn,
      productNameEn: info.productNameEn,
      exportBrandName: info.exportBrandName,
      brand: info.brand,
      brandType: info.brandType,
      remark: info.remark,
      netWeight: info.netWeight
    }, true)
  };

  const openTab: (info: PackBox | BoxItem) => { ["item"]: TabProps } = useCallback((info) => {
    let docLabel = '';
    let docList: string[] = [];
    if (!!(info as BoxItem)?.box) {
      docLabel = ((info as BoxItem)?.box?.boxNumber) + '-' + ((info as BoxItem)?.product?.code) + ' ' + t('common.attachment');
    }
    if (!!(info as PackBox)?.items) {
      docLabel = `${(info as PackBox)?.boxNumber ?? ''} - ${t('common.allFile')}`;
      (info as PackBox)?.items?.forEach(i => i.docId ? docList.push(i.docId) : '')
    }
    return {
      [TAB_ITEM_KEY]: {
        key: TAB_ITEM_KEY,
        label: ((info as PackBox)?.boxNumber) + ' ' + t('warehouse.items'),
        children: <ItemList box={info as PackBox} readonly={readonly} />,
      },
      [TAB_DOC_KEY]: {
        key: TAB_DOC_KEY,
        label: docLabel,
        children: <SDoc docId={(info as BoxItem)?.docId || undefined} isRead={readonly}
          handleNewDocId={(docId) => handleItemDoc((info as BoxItem), docId)}
        />
      },
      [TAB_FILE_LIST]: {
        key: TAB_FILE_LIST,
        label: docLabel,
        children: <WDocFileListTab docList={docList} />
      },
    }
  }, [readonly, handleItemDoc])


  return <CustomTabPane<PackBox | BoxItem> defaultKey={TAB_BOX_KEY} defaultTabs={[
    {
      key: TAB_BOX_KEY,
      label: t("warehouse.boxes"),
      children: <BoxList readonly={readonly} />,
      closable: false,
    },
  ]} onOpens={(info) => openTab(info)} />
};

export default PackBoxHome;